import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import { AccountManagementWithRollout } from 'containers/AccountManagement'
import { MyNetworkWithRollout } from 'containers/MyNetwork'
import { ProfileWithRollout } from 'containers/Profile'
import { SettingsAndPreferencesWithRollout } from 'containers/SettingsAndPreferences'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { MobileAccountMenu } from './MobileAccountMenu'
import { AccountContainer, StyledTabPanel } from './Account.styles'

const subrouteToIndex = {
  profile: 0,
  'my-network': 1,
  management: 2,
  'settings-preferences': 3
}

const indexToSubroute = {
  0: 'profile',
  1: 'my-network',
  2: 'management',
  3: 'settings-preferences'
}

export const AccountContent = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = useMobileMediaQuery()
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2
  const { subroute = 'profile' } = useParams()
  const [activeTabIndex, setActiveTabIndex] = useState(
    subrouteToIndex[subroute] ?? 0
  )

  useEffect(() => {
    setActiveTabIndex(subrouteToIndex[subroute] ?? 0)
  }, [subroute])

  const onTabChange = (id) => {
    setActiveTabIndex(id)
    const nextSubroute = indexToSubroute[id]

    if (nextSubroute) {
      navigate(`/account/${nextSubroute}`)
    }
  }

  return (
    <AccountContainer
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      data-responsive-breakpoints={responsiveBreakpointsVersion}
      data-responsive-breakpoints-page={RESPONSIVE_BREAKPOINT_PAGES.ACCOUNT}
    >
      {isMobile && <MobileAccountMenu />}

      {!isMobile && (
        <>
          <Tonality.UIHeading
            headingStyle="headline2"
            color={theme.colors.neutralW100}
          >
            {t('home.account')}
          </Tonality.UIHeading>
          <Tonality.Tabs
            defaultIndex={activeTabIndex}
            onChange={onTabChange}
            index={activeTabIndex}
            setting="player"
            style={{ margin: '24px 0' }}
          >
            <Tonality.TabList>
              <Tonality.Tab label={t('home.profile')} />
              <Tonality.Tab>
                <span>{t('network.my-network')}</span>
              </Tonality.Tab>
              <Tonality.Tab label={t('home.account-management')} />
              <Tonality.Tab label={t('home.settings-preferences')} />
            </Tonality.TabList>
            <Tonality.TabPanels>
              <StyledTabPanel>
                <ProfileWithRollout />
              </StyledTabPanel>
              <StyledTabPanel>
                <MyNetworkWithRollout style={{ padding: 0 }} />
              </StyledTabPanel>
              <StyledTabPanel>
                <AccountManagementWithRollout />
              </StyledTabPanel>
              <StyledTabPanel>
                <SettingsAndPreferencesWithRollout />
              </StyledTabPanel>
            </Tonality.TabPanels>
          </Tonality.Tabs>
        </>
      )}
    </AccountContainer>
  )
}

export default AccountContent
